/*! @azure/msal-browser-1p v3.23.0 2024-09-03 */
'use strict';
import { PublicClientApplication as PublicClientApplication$1, BrowserPerformanceClient, StubPerformanceClient, AzureCloudInstance } from '@azure/msal-browser';
import { TelemetryReporter } from '../telemetry/TelemetryReporter.mjs';
import { intFields, PerformanceEventAbbreviations } from '../telemetry/TelemetryUtils.mjs';

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
const telemetryAllowedClouds = [
    AzureCloudInstance.AzurePublic,
    AzureCloudInstance.AzurePpe,
];
/**
 * Returns boolean flag, indicating whether telemetry capturing is allowed for the authority
 * @param configuration
 */
function isTelemetryAllowedCloud(configuration) {
    if (!configuration.auth.authority) {
        return true;
    }
    return telemetryAllowedClouds.some((cloud) => configuration.auth.authority?.indexOf(cloud.toString()) === 0);
}
class PublicClientApplication extends PublicClientApplication$1 {
    constructor(configuration, perfTelemetryConfiguration) {
        let performanceClient;
        if (!perfTelemetryConfiguration?.disabled &&
            isTelemetryAllowedCloud(configuration)) {
            performanceClient =
                configuration.telemetry?.client ||
                    new BrowserPerformanceClient(configuration, new Set(intFields), new Map(PerformanceEventAbbreviations));
            super({
                ...configuration,
                telemetry: {
                    ...configuration.telemetry,
                    client: performanceClient,
                },
            });
        }
        else {
            super(configuration);
            performanceClient = new StubPerformanceClient();
        }
        this.performanceClient = performanceClient;
        /*
         * TODO: Don't initialize wrapper until eSTS is updated to include new SKU
         * this.initializeWrapperLibrary(WrapperSKU.FirstParty, version);
         */
        const telemetryReporter = new TelemetryReporter(this.getLogger(), perfTelemetryConfiguration);
        this.addPerformanceCallback(telemetryReporter.getTelemetryCallback());
    }
    static async createPublicClientApplication(configuration, perfTelemetryConfiguration, correlationId) {
        const pca = new PublicClientApplication(configuration, perfTelemetryConfiguration);
        await pca.initialize({ correlationId });
        return pca;
    }
}

export { PublicClientApplication };
//# sourceMappingURL=PublicClientApplication.mjs.map
